/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const bottomCabinetApplianceComponents = [
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'default', true).withAlias('BottomCabinetAppliance').attach(memoEval((self)=>[
            self.$applianceOffsetX,
            self.$applianceOffsetY,
            self.$applianceOffsetZ
        ], ($applianceOffsetX, $applianceOffsetY, $applianceOffsetZ)=>({
            offsetX: $applianceOffsetX,
            offsetY: $applianceOffsetY,
            offsetZ: $applianceOffsetZ
        })))
];

//# sourceMappingURL=bottom-cabinet-appliance.js.map